export const projectAdmin = {
    emailDialog: {
      title: "Set Notification Email",
      description: "To receive notifications when users submit or respond to recordings, and to receive monthly collection and listen data reports, we need to collect your email address.",
      emailLabel: "Email Address",
      emailHelper: "Email address for notifications and monthly reports",
      saveButton: "Save Email",
      error: "Failed to update email. Please try again.",
      consentRequired: "Please consent to data collection to continue"
    },
    monthlyReport: {
      subject: "Monthly Report - {{projectName}} ({{period}})",
      title: "Monthly Project Report - {{projectName}}",
      period: "Report Period: {{start}} - {{end}}",
      statistics: "PROJECT STATISTICS",
      totalRecordings: "Total Recordings",
      totalResponses: "Total User Responses",
      totalListens: "Total Listens",
      totalCollections: "Total Collections",
      projectDetails: "PROJECT DETAILS",
      projectName: "Project Name",
      projectId: "Project ID",
      footer: "This is an automated monthly report. You can view more detailed analytics in your project admin console."
    },
    notifications: {
      newSubmission: "New Submission Received",
      newResponse: "New Response Received",
      submissionSubject: "New Submission to Project: {{projectName}}",
      responseSubject: "New Response to Recording: {{recordingTitle}}"
    }
}